import React from 'react';

import cs from 'classnames';

import {gt} from 'app/utils/i18n';

import {FormItem} from './BaseFormField';

import type {FormItemProps} from './BaseFormField';

interface Props extends Omit<FormItemProps, 'children'> {
  disabled?: boolean;
  maxLength?: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => unknown;
  value: string;
  name: string;
}

export function TextboxField({
  id,
  name,
  value,
  onChange,
  disabled,
  maxLength,
  ...props
}: Props) {
  return (
    <FormItem id={id} {...props}>
      <div className="col-12 col-sm-10 col-md-6">
        <input
          id={id}
          name={name}
          disabled={disabled}
          type="text"
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          className={cs('form-control', {'is-invalid': value === ''})}
        />
        {value === '' && (
          <div className="invalid-feedback">{gt('Required')}</div>
        )}
      </div>
    </FormItem>
  );
}
